export abstract class MicrosoftAuthBaseService {
   abstract initialize(): Promise<string | null>;
  abstract loginMicrosoft(): Promise<void>;
  abstract logoutMicrosoft(): Promise<void>;
  abstract isLoggedIn(): boolean;
}